<success-screen class="bp-modal mod-lg">
	<bp-modal-header header [title]="'verify-account' | translate">
		<a right (click)="close()" (keydown.enter)="close()" [tabIndex]="0">{{ "close" | translate }}</a>
	</bp-modal-header>
	<div content class="success-content-inner">
		<div id="sumsub-websdk-container"></div>
		@if (!verificationApplication.name.includes('sumsub')) {
			<div class="success-symbol mt-20 mb-20 mod-email">
				<svg-inline
					class="icon-status-forward"
					src="assets/images/icon-status-forward.svg"
					[alt]="'forward_alt_text' | translate" />
			</div>
			<div class="success-headline mb-15">
				{{ "forwarding-to-id-provider" | translate: [verificationApplication?.display_name] }}
			</div>
			<p class="text-light text-center mb-15">{{ "forwarding-to-id-provider-text" | translate }}</p>
			<div class="text-center">
				<a [href]="verificationApplication?.url" target="_blank">
					{{ "open-id-provider-manually" | translate }}
				</a>
			</div>
		}

	</div>
</success-screen>
